import { createContext } from '@companydotcom/potion';
const [SourceProvider, useSource] = createContext({
    name: 'SourceContext',
    errorMessage: 'useSource: `source` is undefined. Seems you forgot to wrap the app in `<SourceProvider />` ',
});
export { SourceProvider, useSource };
